import React, { useRef, useState } from "react";
import "./otayhteytta.css";
import emailjs from "@emailjs/browser";

export default function OtaYhteytta() {
    const form = useRef();

    const [submitted, setSubmitted] = useState(false);


    const sendEmail = (e) => {
      e.preventDefault();


  
      emailjs
        .sendForm(
          "service_ohaa78j",  
          "template_rtvfvvh", 
          form.current,
          "_PhycNW2TDRqEuePx"    
        )
        .then(
          (result) => {
            setSubmitted(true);
            
          },
          (error) => {
            alert("Viestin lähetys epäonnistui. Yritä uudelleen.");
            console.error(error.text);
          }
        );
                setSubmitted(true);
        setTimeout(() => setSubmitted(false), 10000);
  
      e.target.reset();
    };
  return (
    <div className="contact-page">
      {}
      <div className="contact">
        <h1>Yhteystiedot</h1>

        <div className="contact-info">
          <p> Vääksyntie 4, 17200 Vääksy</p>
          <p>Vapaudenkatu 8, 15110 Lahti</p>
          <p>Avoinna sopimuksen mukaan.</p>
          <br>
          </br>
          <p>lakiasiat@sarikolsi.fi</p>
          <p>044-7772797</p>
          <br></br>

        </div>

        <form ref={form} onSubmit={sendEmail} className="contact-form">
          <div className="form-row">
            <div className="form-group">
              <label>Nimi</label>
              <input type="text" name="nimi" required />
            </div>
            <div className="form-group">
              <label>Sähköposti</label>
              <input type="email" name="email" required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Puhelin</label>
              <input type="text" name="puhelin" required />
            </div>
            <div className="form-group">
              <label>Osoite</label>
              <input type="text" name="osoite" required />
            </div>
          </div>

          <div className="form-group">
            <label>Aihe</label>
            <input type="text" name="aihe" required />
          </div>

          <div className="form-group">
            <label>Kerro lyhyesti, millaista palvelua tarvitset.</label>
            <textarea name="viesti" required></textarea>
          </div>

          <button type="submit">Lähetä</button>

        </form>
        {

        }
        {submitted && (
          <p className="success-message">
            Kiitos yhteydenotostasi! Vastaan siihen mahdollisimman pian!
          </p>
        )}


      </div>

     
    </div>
  );
}
